'use strict';

module.exports = function (angularModule) {
  angularModule
      .constant('AUTH_API_BASE', '/redi/idp/oauth2')
      .config(require('./httpConfig'))
      .run(require('./rediTokenRefreshSetup'))
      .service('authApiFactory', require('./authApiFactory'))
      .factory('authInterceptor', require('./authInterceptor'));
};



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/infrastructure/index.js
// module id = 123
// module chunks = 0